/** Where the page's theme is kept and what it starts as, for the app and its boot script. */
export const themeOptions = {
  key: "system-bridge:theme",
  defaultTheme: "bridge",
} as const;
